import { WeaveCopilotService } from '@weave/schema-gen-ts/dist/schemas/clm-ai/copilot/v1/copilot.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaWeaveCopilotV1Service = bindHTTP(WeaveCopilotService);
export const serviceName = 'weave-copilot-v1' as const;
